import OutlinedInput from '@mui/material/OutlinedInput';

export { OutlinedInput };
